import { MdKeyboardArrowRight } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as S from "./styles";

interface BreadcrumbProps {
  customBreadcrumbString?: string;
}

export function Breadcrumb({ customBreadcrumbString }: BreadcrumbProps) {
  const location = useLocation();
  const path = location.pathname;
  const pathnames = path.split("/").filter(Boolean);
  const { t } = useTranslation();

  const breadcrumbTranslations: Record<string, string> = {
    inventory: t("inventory"),
    report: t("report"),
    settings: t("settings"),
    profile: t("profile"),
    "item-search": t("itemSearch"),
    "auto-print": t("autoPrint"),
    "duplicated-items": t("duplicatedItems"),
    orders: t("orders"),
    dynamicReport: t("dynamicReport"),
    salesTaxReport: t("salesTaxReport"),
    users: t("users"),
    stores: t("stores"),
    roles: t("roles"),
    "fulfillment-priority": t("fulfillmentPriority"),
    create: t("new"),
  };

  const translatePathname = (pathname: string): string => {
    return breadcrumbTranslations[pathname] || pathname;
  };

  return (
    <S.BreadcrumbContainer>
      {pathnames &&
        pathnames.map((route, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <div key={route}>
              <S.TextLink
                end={isLast}
                to={routeTo}
                isCustomBreadcrumbString={!!customBreadcrumbString}
              >
                <span>
                  {isLast && customBreadcrumbString
                    ? customBreadcrumbString
                    : translatePathname(route)}
                </span>
              </S.TextLink>
              {!isLast && <MdKeyboardArrowRight size={20} />}
            </div>
          );
        })}
    </S.BreadcrumbContainer>
  );
}
